import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';
import { AuthenticFormVM } from 'front-office/view-models/authentic/authentic-form';
import { DateTime } from 'luxon';
import { RequestCertificateGeneric } from 'shell/models/request-generic';

export const transformRequestAuthenticData = (
  values: AuthenticFormVM
): RequestCertificateGeneric => {
  const hasGenerality =
    (values.generality &&
      (values.applicant?.fiscalCode || values.applicant?.name || values.applicant?.surname)) ||
    values.applicant;

  const generalitaRichiedente = hasGenerality
    ? {
        docRiconoscimento:
          values.generality?.dateReleaseDocument || values.generality?.numberDocument
            ? {
                dataRilascio: values.generality?.dateReleaseDocument?.toFormat('yyyy-MM-dd'),
                estDocRiconoscimento: values.generality?.numberDocument,
              }
            : undefined,
        generalita: hasGenerality
          ? {
              idSchedaSoggettoANPR: values.generality?.idSubjectAnpr || undefined,
              codiceFiscale: values.applicant?.fiscalCode
                ? {
                    codFiscale: values.applicant?.fiscalCode,
                  }
                : undefined,
              nome: values.applicant?.name,
              cognome: values.applicant?.surname,
              senzaNome: values.applicant?.withoutName ? '1' : undefined,
              senzaCognome: values.applicant?.withoutSurname ? '1' : undefined,
              sesso: values.applicant?.gender,
              dataNascita: values.generality?.birthDate?.toFormat('yyyy-MM-dd'),
              senzaGiorno:
                !values.generality?.birthChoiceDate?.includes('day') &&
                values.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              senzaGiornoMese:
                !values.generality?.birthChoiceDate?.includes('day') &&
                !values.generality?.birthChoiceDate?.includes('month') &&
                values.generality?.birthDate
                  ? '1'
                  : undefined,
              luogoNascita:
                values.generality?.municipalityOfBirth || values.generality?.foreignStateBirth
                  ? {
                      comune:
                        !values.generality?.isForeign && values.generality?.municipalityOfBirth
                          ? {
                              nomeComune: values.generality?.municipalityOfBirth?.description,
                              siglaProvinciaIstat: values.generality?.municipalityOfBirth?.province,
                              descrizioneLocalita: values.generality?.locality,
                            }
                          : undefined,
                      localita:
                        values.generality?.isForeign && values.generality?.foreignStateBirth
                          ? {
                              codiceStato: values.generality?.foreignStateBirth?.id,
                              descrizioneStato: values.generality?.foreignStateBirth?.value,
                              provinciaContea: values.generality?.foreignStateBirth?.province,
                              descrizioneLocalita:
                                values.generality?.foreignMunicipality?.description,
                            }
                          : undefined,
                    }
                  : undefined,
            }
          : undefined,
      }
    : undefined;

  const generalitaIntestatario = values.accountholder
    ? {
        generalita: values.accountholder
          ? {
              idSchedaSoggettoANPR:
                values.accountholder?.account?.generality?.idSubjectAnpr || undefined,
              codiceFiscale: values.accountholder?.account?.applicant?.fiscalCode
                ? {
                    codFiscale: values.accountholder?.account?.applicant?.fiscalCode,
                  }
                : undefined,
              nome: values.accountholder?.account?.applicant?.name,
              cognome: values.accountholder?.account?.applicant?.surname,
              senzaNome: values.accountholder?.account?.applicant?.withoutName ? '1' : undefined,
              senzaCognome: values.accountholder?.account?.applicant?.withoutSurname
                ? '1'
                : undefined,
              sesso: values.accountholder?.account?.applicant?.gender || '',
              dataNascita:
                values.accountholder?.account?.applicant?.birthDate?.toFormat('yyyy-MM-dd') ||
                values.accountholder?.account?.generality?.birthDate?.toFormat('yyyy-MM-dd'),
              senzaGiorno:
                !values.accountholder?.account?.generality?.birthChoiceDate?.includes('day') &&
                values.accountholder?.account?.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              senzaGiornoMese:
                values.accountholder?.account?.generality?.birthDate &&
                !values.accountholder?.account?.generality?.birthChoiceDate?.includes('day') &&
                !values.accountholder?.account?.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              luogoNascita:
                values.accountholder?.account?.generality?.municipalityOfBirth ||
                values.accountholder?.account?.generality?.foreignStateBirth
                  ? {
                      comune:
                        !values.accountholder?.account?.generality?.isForeign &&
                        values.accountholder?.account?.generality?.municipalityOfBirth
                          ? {
                              nomeComune:
                                values.accountholder?.account?.generality?.municipalityOfBirth
                                  ?.description,
                              siglaProvinciaIstat:
                                values.accountholder?.account?.generality?.municipalityOfBirth
                                  ?.province,
                              descrizioneLocalita:
                                values.accountholder?.account?.generality?.locality,
                            }
                          : undefined,
                      localita:
                        values.accountholder?.account?.generality?.isForeign &&
                        values.accountholder?.account?.generality?.foreignStateBirth
                          ? {
                              codiceStato:
                                values.accountholder?.account?.generality?.foreignStateBirth?.id,
                              descrizioneStato:
                                values.accountholder?.account?.generality?.foreignStateBirth?.value,
                              provinciaContea:
                                values.accountholder?.account?.generality?.foreignStateBirth
                                  ?.province,
                              descrizioneLocalita:
                                values.accountholder?.account?.generality?.foreignMunicipality
                                  ?.description,
                            }
                          : undefined,
                    }
                  : undefined,
            }
          : undefined,
      }
    : undefined;

  const generalitaIntestatarioSameAsApplicant = hasGenerality
    ? {
        generalita: hasGenerality
          ? {
              idSchedaSoggettoANPR: values.generality?.idSubjectAnpr || undefined,
              codiceFiscale: values.applicant?.fiscalCode
                ? {
                    codFiscale: values.applicant?.fiscalCode,
                  }
                : undefined,
              nome: values.applicant?.name,
              cognome: values.applicant?.surname,
              senzaNome: values.applicant?.withoutName ? '1' : undefined,
              senzaCognome: values.applicant?.withoutSurname ? '1' : undefined,
              sesso: values.applicant?.gender,
              dataNascita: values.generality?.birthDate?.toFormat('yyyy-MM-dd'),
              senzaGiorno:
                !values.generality?.birthChoiceDate?.includes('day') &&
                values.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              senzaGiornoMese:
                !values.generality?.birthChoiceDate?.includes('day') &&
                !values.generality?.birthChoiceDate?.includes('month') &&
                values.generality?.birthDate
                  ? '1'
                  : undefined,
              luogoNascita:
                values.generality?.municipalityOfBirth || values.generality?.foreignStateBirth
                  ? {
                      comune:
                        !values.generality?.isForeign && values.generality?.municipalityOfBirth
                          ? {
                              nomeComune: values.generality?.municipalityOfBirth?.description,
                              siglaProvinciaIstat: values.generality?.municipalityOfBirth?.province,
                              descrizioneLocalita: values.generality?.locality,
                            }
                          : undefined,
                      localita:
                        values.generality?.isForeign && values.generality?.foreignStateBirth
                          ? {
                              codiceStato: values.generality?.foreignStateBirth?.id,
                              descrizioneStato: values.generality?.foreignStateBirth?.value,
                              provinciaContea: values.generality?.foreignStateBirth?.province,
                              descrizioneLocalita:
                                values.generality?.foreignMunicipality?.description,
                            }
                          : undefined,
                    }
                  : undefined,
            }
          : undefined,
      }
    : undefined;

  const cdCertificato = values.authentics
    ? `AU${values.authentics.key.codiceDocumento}`
    : undefined;

  const indirizzoResidenzaIntestatario = values.generality?.addressString || '';

  const comuneResidenzaIntestatario = values.generality?.residenceString || '';
  let cartaIdentitaComuneRilascio = '';

  if (values?.accountholder?.sameApplicant) {
    if (values?.generality?.isForeignDocument === DocumentRadioCertificate.Other) {
      cartaIdentitaComuneRilascio = values.generality?.consulateCode || '';
    } else if (values?.generality?.isForeignDocument === DocumentRadioCertificate.IdentityCard) {
      cartaIdentitaComuneRilascio = values.generality?.municipalityDocument?.description
        ? `Comune di ${values.generality?.municipalityDocument?.description}`
        : '';
    }
  } else if (
    values?.accountholder?.account?.generality?.isForeignDocument !==
    DocumentRadioCertificate.Witness
  ) {
    if (values.accountholder?.account?.generality?.consulateCode) {
      cartaIdentitaComuneRilascio = values.accountholder?.account?.generality?.consulateCode || '';
    } else {
      cartaIdentitaComuneRilascio = values.generality?.municipalityDocument?.description
        ? `Comune di ${values.generality?.municipalityDocument?.description}`
        : '';
    }
  }

  let documentoIdentita = '';

  let numeroCarta = '';

  if (values?.accountholder?.sameApplicant) {
    numeroCarta =
      values.generality?.isFromAnpr &&
      values.generality?.isForeignDocument === DocumentRadioCertificate.IdentityCard
        ? `Carta d'identità n.${values.generality?.numberDocument || ''}`
        : values.generality?.numberDocument || '';

    documentoIdentita = `${numeroCarta || ''}
      rilasciato il ${
        values.generality?.dateReleaseDocument
          ? values.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy')
          : ''
      } da ${cartaIdentitaComuneRilascio}`;
  } else {
    numeroCarta =
      values.accountholder?.account?.generality?.isFromAnpr &&
      values.accountholder?.account?.generality?.isForeignDocument ===
        DocumentRadioCertificate.IdentityCard
        ? `Carta d'identità n.${values?.accountholder?.account?.generality?.numberDocument || ''}`
        : values?.accountholder?.account?.generality?.numberDocument || '';

    documentoIdentita = `${numeroCarta || ''} rilasciato il ${
      values?.accountholder?.account?.generality?.dateReleaseDocument
        ? values?.accountholder?.account?.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy')
        : ''
    } da ${cartaIdentitaComuneRilascio}`;
  }

  let testimone1 = undefined,
    testimone2 = undefined;

  if (
    values?.accountholder?.sameApplicant &&
    values?.generality?.isForeignDocument === DocumentRadioCertificate.Witness
  ) {
    testimone1 = {
      testimone1: values.generality?.witness1 || undefined,
      documentoTestimone1: values.generality?.witness1IdentityCard || undefined,
    };

    testimone2 = {
      testimone2: values.generality?.witness2 || undefined,
      documentoTestimone2: values.generality?.witness2IdentityCard || undefined,
    };
  } else if (
    !values?.accountholder?.sameApplicant &&
    values?.accountholder?.account?.generality?.isForeignDocument ===
      DocumentRadioCertificate.Witness
  ) {
    testimone1 = {
      testimone1: values.accountholder?.account?.generality?.witness1 || undefined,
      documentoTestimone1:
        values.accountholder?.account?.generality?.witness1IdentityCard || undefined,
    };

    testimone2 = {
      testimone2: values.accountholder?.account?.generality?.witness2 || undefined,
      documentoTestimone2:
        values.accountholder?.account?.generality?.witness2IdentityCard || undefined,
    };
  }

  let provinciaResidenzaIntestatario = '';

  if (values?.generality?.residence?.indirizzo) {
    provinciaResidenzaIntestatario =
      values.generality?.residence?.indirizzo?.comune?.siglaProvinciaIstat || '';
  } else if (values.generality?.residence?.localitaEstera?.indirizzoEstero?.localita) {
    provinciaResidenzaIntestatario =
      values.generality?.residence?.localitaEstera?.indirizzoEstero?.localita?.provinciaContea ||
      '';
  }

  let luogoNascitaIntestatario = undefined;
  if (values?.accountholder?.sameApplicant) {
    if (!values?.generality?.isForeign) {
      luogoNascitaIntestatario = values?.generality?.municipalityOfBirth?.description || '';
    } else {
      luogoNascitaIntestatario = values?.generality?.foreignMunicipality?.description || '';
    }
  } else {
    if (values?.accountholder?.account?.generality?.foreignMunicipality) {
      luogoNascitaIntestatario =
        values?.accountholder?.account?.generality?.foreignMunicipality?.description || '';
    } else {
      luogoNascitaIntestatario =
        values?.accountholder?.account?.generality?.municipalityOfBirth?.description || '';
    }
  }

  return {
    generalitaRichiedente,
    flagDocumento:
      values.generality?.isForeignDocument === DocumentRadioCertificate.Witness ||
      values.accountholder?.account?.generality?.isForeignDocument ===
        DocumentRadioCertificate.Witness
        ? 'N'
        : 'S',
    testimone1: testimone1?.testimone1 || undefined,
    documentoTestimone1: testimone1?.documentoTestimone1 || undefined,
    testimone2: testimone2?.testimone2 || undefined,
    documentoTestimone2: testimone2?.documentoTestimone2 || undefined,
    cdCertificato,
    motivoRilascio: values.accountholder?.account?.applicant?.releaseReason || values.reasonRelease,
    usoInterno: values?.certificateInternOnly,
    cognomeIntestatario: values?.accountholder?.sameApplicant
      ? values.applicant?.surname
      : values?.accountholder?.account?.applicant?.surname,
    nomeIntestatario: values?.accountholder?.sameApplicant
      ? values.applicant?.name
      : values.accountholder?.account?.applicant?.name,
    dataNascitaIntestatario: values?.accountholder?.sameApplicant
      ? values.generality?.birthDate?.toFormat('dd/MM/yyyy')
      : values.accountholder?.account?.applicant?.birthDate?.toFormat('dd/MM/yyyy') ||
        values.accountholder?.account?.generality?.birthDate?.toFormat('dd/MM/yyyy'),
    luogoNascitaIntestatario: luogoNascitaIntestatario,
    cittadino: values?.accountholder?.sameApplicant
      ? values.applicant?.gender
      : values.accountholder?.account?.applicant?.gender,
    // comune residenza, provincia residenza, indirizzo residenza
    comuneResidenzaIntestatario,
    provinciaResidenzaIntestatario,
    documentoIdentita,
    dataResidenzaIntestatario: values.generality?.residence?.dataDecorrenzaResidenza
      ? DateTime.fromISO(values.generality?.residence?.dataDecorrenzaResidenza).toFormat(
          'dd/MM/yyyy'
        )
      : undefined,
    // indirizzoResidenzaIntestatario,
    // cittadiniTitoloCertificato ????
    // idFamigliaConvivenzaANPR
    idFamigliaConvivenzaANPR: values.generality?.idFamilyAnpr,
    cartaIdentitaNRIntestatario: numeroCarta || undefined,
    cartaIdentitaRilasciataIl: values?.accountholder?.sameApplicant
      ? values.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy')
      : values?.accountholder?.account?.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy'),
    cartaIdentitaComuneRilascio: cartaIdentitaComuneRilascio || undefined,
    // familiareUE: values.generality?.foreignStateBirth ? 'S' : 'N', // Da verificare
    generalitaIntestatario: values?.accountholder?.sameApplicant
      ? generalitaIntestatarioSameAsApplicant?.generalita
      : generalitaIntestatario?.generalita,
    tipoPagamento: values.typePayment,
    tipoDocumento: values.authentics,
    codiceStato: values.generality?.idState,
    // tipo indirizzo
    tipoIndirizzo: values.generality?.residence?.tipoIndirizzo,
    figlio: [],
    indirizzoResidenzaIntestatario,
    // modalita rilascio
    codiceModalitaRilascio: values.modality?.id as string,
  };
};
